import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useSidebar } from '../../context/SidebarContext';

/** Matches --sidebar-brand-icon-size in index.css */
const ICON_SIZE = 40;

/**
 * Logo toggle control — wordmark in expanded sidebar, circular icon anchor when collapsed.
 * Click compresses / expands the sidebar around the icon.
 */
export default function SidebarBrand() {
  const { isDark } = useTheme();
  const { effectiveCollapsed, toggleSidebar } = useSidebar();

  const wordmarkSrc = isDark ? '/logo-light.png' : '/logo-dark.png';
  const iconSrc = isDark ? '/logo-icon-dark.png' : '/logo-icon-light.png';
  const collapseLabel = effectiveCollapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <button
      type="button"
      className="app-sidebar-brand"
      onClick={toggleSidebar}
      aria-label={collapseLabel}
      aria-expanded={!effectiveCollapsed}
      title={collapseLabel}
    >
      <span className="app-sidebar-brand__anchor" aria-hidden="true">
        <img
          src={iconSrc}
          alt=""
          className="app-sidebar-brand__icon"
          width={ICON_SIZE}
          height={ICON_SIZE}
          draggable={false}
        />
        <span className="app-sidebar-brand__wordmark-wrap">
          <img
            src={wordmarkSrc}
            alt="Stavyn"
            className="app-sidebar-brand__wordmark"
            draggable={false}
          />
        </span>
      </span>
    </button>
  );
}
